import { css } from '@emotion/core';
import { StyledColumnWrapper } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css(".flex-row{display:flex;justify-content:center;align-items:center;}.image-box{padding:0;margin:0 0.8em;}", StyledColumnWrapper, "{&.flex--top{align-items:flex-start;}&.flex--center{align-items:center;}&.flex--stretch{align-items:stretch;}&.flex--bottom{align-items:flex-end;}}");
});